import { linkUrlGroq } from "../sanity/schemas/link";
import { validate } from "../sanity/utils/validate";
import { richTextGroq } from "./RichText.sanity";

export const textLinksSchema = {
  type: "object",
  name: "textLinks",
  fields: [
    {
      name: "title",
      type: "string",
      validation: validate({ required: true }),
    },
    {
      name: "intro",
      type: "text",
      validation: validate({ required: true }),
    },
    {
      name: "links",
      type: "array",
      of: [
        {
          type: "object",
          fields: [
            {
              name: "title",
              type: "string",
              validation: validate({ required: true }),
            },
            {
              name: "text",
              type: "richText",
              validation: validate({ required: true }),
            },
            {
              name: "linkLabel",
              type: "string",
              validation: validate({ required: true }),
            },
            {
              name: "url",
              type: "linkUrl",
              validation: validate({ required: true }),
            },
          ],
        },
      ],
    },
  ],
};

export const textLinksGroq = `
  ...,
  "links": links{
    ...,
    "text": text[]{
      ${richTextGroq}
    },
    "url": ${linkUrlGroq}
  }[]
`;
